/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-case-declarations */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { EditorState } from 'draft-js';
import { Box } from '@mui/material';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
const { useState } = React;
function TextEditor(props) {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  return (
    <Box className="RichEditor-root rounded-xl " style={{ height: 'auto' }}>
      <Editor
        defaultEditorState={editorState}
        wrapperClassName="wrapper-class"
        wrapperStyle={{ height: 'auto' }}
        onEditorStateChange={setEditorState}
        toolbar={{
          options: ['inline', 'link', 'list'],
          inline: {
            options: ['bold', 'italic'],
          },
          list: {
            options: ['unordered', 'ordered'],
          },
        }}
      />
    </Box>
  );
}

// Custom overrides for "code" style.

export default TextEditor;
